export default {
  element_selector: ".lazy"
};
